import { FaRegCheckCircle } from 'react-icons/fa';

import {
  AvatarOnlineWrapper,
  IndividualUserWrapper,
} from '../../pages/Message/style';
import { fake_avatar_url } from '../../utils';
import Avatar from '../Avatar';
import Typography from '../Typography';

type Props = {
  onclick?: () => void;
  isOnline?: boolean;
  name: string;
  lastMessage: string;
  lastMessageDate: string;
  hasCheckedMessage?: boolean;
  role?: 'technician' | 'printer' | 'draftman' | 'fireTeam';
};
const IndividualUserMessageWrapper = ({
  onclick,
  isOnline,
  name,
  lastMessage,
  lastMessageDate,
  hasCheckedMessage,
  role,
}: Props) => {
  return (
    <IndividualUserWrapper onClick={onclick}>
      {' '}
      <AvatarOnlineWrapper className="avatar" $isOnline={isOnline}>
        <Avatar src={fake_avatar_url} size={'lg'} />
      </AvatarOnlineWrapper>
      <div className="user-info-wrapper">
        <div className="user-info">
          <Typography fontColor="dark">{name}</Typography>
          <Typography variant="caption">{lastMessage}</Typography>
          <Typography variant="smallText" fontColor="disableButton">
            {lastMessageDate}
          </Typography>
        </div>
        <div>
          {isOnline ? <div className="message-status-wrapper" /> : null}
          {hasCheckedMessage ? (
            <FaRegCheckCircle
              color="green"
              size={12}
              style={{ marginTop: '5px' }}
            />
          ) : (
            <div className={`unread-msg ${role}`} />
          )}
        </div>
      </div>
    </IndividualUserWrapper>
  );
};

export default IndividualUserMessageWrapper;
